import { LoveEatPage } from "./pages/love-eat"

export const loveEat = {
  themeOptionFactory: null,
  ignoreAppThemeFactory: false,
  routes: {
    mobile: [
      {
        path: "love-eat",
        element: <LoveEatPage />,
      },
    ],
    "kiosk-v": [],
    "kiosk-h": [],
  },
}
